export const MONEY_FORMAT = {
  zeroFractionDigits: true,
} as const
